import Customer from '@models/customer';
import CustomerLocation from '@models/customer-location';

const defaultState = {
    customer: new Customer(),
    locations: [],
    selectedLocationId: null,
    currentLocation: {},
    showCancelled: false,
};

export default {
    namespaced: true,
    state: defaultState,
    getters: {
        isStatic() {
            return false;
        },
    },
    mutations: {
        setCustomer(state, customer) {
            state.customer = customer;
        },
        setCustomerLocations(state, locations) {
            state.locations = locations;
        },
        setSelectedLocationId(state, locationId) {
            state.selectedLocationId = !locationId ? null : Number(locationId);
        },
        setCurrentLocation(state, location) {
            state.currentLocation = location;
        },
        resetState(state) {
            Object.assign(state, defaultState);
        },
        updateCurrentLocation(state, updateLocation) {
            state.currentLocation = updateLocation;
        },
        setShowCancelled(state, showCancelled) {
            state.showCancelled = showCancelled;
        },
    },
    actions: {
        async refresh({ dispatch, state, commit }) {
            dispatch('getCustomer', state.customer.id);
            await dispatch('getCustomerLocations');

            if (state.currentLocation) {
                const location = state.locations.find((l) => state.currentLocation.id === l.id);
                commit('updateCurrentLocation', location);
            }
        },
        async getCustomer({ commit }, customerId) {
            const customer = await Customer.with('industry', 'accountManagers').find(customerId);

            commit('setCustomer', customer);
        },
        async getCustomerLocations({ commit, state }) {
            const locations = await CustomerLocation.for(state.customer).orderBy('code').get();
            commit('setCustomerLocations', locations);
        },
        async setSelectedLocationId({ commit, state }, locationId) {
            commit('setSelectedLocationId', locationId);
            commit('setCurrentLocation', state.locations.find((l) => l.id == locationId || l.uuid == locationId));
        },
        async reset({ commit }) {
            commit('resetState');
        },
    },
};
